<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    light
    floating
    persistent
    mobile-breakpoint="991"
    width="260"
  >
    <v-layout tag="v-list" column>
      <v-list-item class="logowrapper">
        <v-list-item-avatar>
          <v-img :src="logo" height="64" contain />
        </v-list-item-avatar>
        <v-list-item-title class="title">{{$store.getters.applicationtitle}}</v-list-item-title>
      </v-list-item>
      <v-divider />
      <menu-list name="parentmenu" :list="parentMenus"></menu-list>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState } from "vuex";
import MenuList  from "../shared/MenuList";
import store from "../../store";
export default {
  components: {
    MenuList
  },
  data: () => ({
    logo: store.getters.company.logo,
    responsive: false
  }),
  computed: {
    ...mapState("app", ["image", "color"]),
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      }
    },
    items() {
      return this.$t("Layout.View.items");
    },
    parentMenus() {
      if (this.$store.getters.usermenu.length > 0) {
        return this.$store.getters.usermenu.filter(c => {
          return c.parentpagekey == null;
        });
      } else return [];
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  }
};
</script>

<style lang="scss">
#app-drawer {
  .v-list-item {
    border-radius: 4px;

    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }

  .v-image__image--contain {
    top: 9px;
    height: 60%;
  }

  .search-input {
    margin-bottom: 30px !important;
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
